<div>
  <sc-flex [stretchContent]="true">
    <mat-form-field appearance="fill">
      <mat-label>Servicefahrzeug</mat-label>
      <mat-select [formControl]="serviceTruckSelectionControl">
        <mat-option *ngFor="let value of serviceTruckOptions" [value]="value">
          {{value.identifier}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container *ngIf="truckGroupsEnabled">
      <ng-container *ngFor="let tg of truckGroupsOfSelectedTruck">
        <sc-content-spacer></sc-content-spacer>
        <sc-bordered [rounded]="true" [highlight]="tg.id === selectedTruckGroup?.id"
          (click)="selectTruckGroup(tg)">
          <sc-padding>
            {{tg.name}}
          </sc-padding>
        </sc-bordered>
      </ng-container>
    </ng-container>
  </sc-flex>
</div>

<sc-paged-content [configuration]="configuration" [data]="data" [readOnly]="true" (selectionChanged)="onSelectionChanged($event)" [selected]="selectedItem">
  <sc-no-data-container fitHeight [hasData]="selectedItem">
    <ng-container *ngIf="selectedItem">
          <!-- <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
            <sc-flex-fitting-content [vertical]="true"> -->
              <app-movement-order-details [movementOrderDetailsId]="movementOrderDetails?.id"
                [serviceTruckId]="selectedServiceTruck?.truckId" (detailsChanged)="onMovementOrderDetailsChanged()">
              </app-movement-order-details>
            <!-- </sc-flex-fitting-content>
          </sc-flex> -->
        </ng-container>
  
  </sc-no-data-container>

</sc-paged-content>



